const buttonStyle = { height: '100%' };

export { buttonStyle };
